import { render, staticRenderFns } from "./courseDaySidebar.vue?vue&type=template&id=8194c262&scoped=true&lang=pug&"
import script from "./courseDaySidebar.vue?vue&type=script&lang=js&"
export * from "./courseDaySidebar.vue?vue&type=script&lang=js&"
import style0 from "./courseDaySidebar.vue?vue&type=style&index=0&id=8194c262&lang=scss&scoped=true&"
import style1 from "./courseDaySidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8194c262",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VProgressLinear,VSkeletonLoader})
